import { cn } from '@rocco/utils/cn';
import type { PartialConversation } from '../../types';
import {
    ChatInboxListItem,
    ChatInboxListItemSkeleton,
} from './ChatInboxListItem';

/**
 * The chat inbox list. This is an infinite scrolling list of conversations
 * belonging to the current user.
 * @see {@link ChatInboxDrawer}
 */
export function ChatInboxList({
    className,
    conversations,
    isLoading,
}: {
    className?: string;
    conversations: PartialConversation[];
    isLoading: boolean;
}) {
    return (
        <ul
            className={cn('flex flex-col gap-2 overflow-y-auto', className)}
            aria-label="Chat inbox"
            aria-live="polite"
            aria-busy={isLoading}
        >
            {isLoading
                ? Array.from({ length: 8 }).map((_, index) => (
                      <ChatInboxListItemSkeleton key={index} />
                  ))
                : conversations.map((conversation) => (
                      <ChatInboxListItem
                          key={conversation.ID}
                          conversation={conversation}
                      />
                  ))}
        </ul>
    );
}
